import type { AuthRecoveryState } from './AuthContext';

export function shouldPauseAppPolling(state: AuthRecoveryState): boolean {
  return state !== 'ready';
}

/** All live editor resources are reloaded when recovery reaches ready. */
export function shouldReloadAfterRecovery(previous: AuthRecoveryState, next: AuthRecoveryState): boolean {
  return previous !== 'ready' && next === 'ready';
}
